// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__IWh3Q","checkboxCol":"Table_checkboxCol__1soCX","emailCol":"Table_emailCol__2-ZCq","actionCol":"Table_actionCol__2Ftg8"};